import { render, staticRenderFns } from "./ManuscriptSelectContent.vue?vue&type=template&id=349a2860&scoped=true"
import script from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
export * from "./ManuscriptSelectContent.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptSelectContent.vue?vue&type=style&index=0&id=349a2860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349a2860",
  null
  
)

export default component.exports